export default "__VITE_ASSET__1b355873__"